import { PaginationRequest } from '../types';
import apiService from './api.service';

export enum SyntheticType {
  ACTIVE_USER = 'ACTIVE_USER',
  JOIN_FANCLUB = 'JOIN_FANCLUB',
  MATCH = 'MATCH',
  JOIN_MINI_GAME = 'JOIN_MINI_GAME',
  JOIN_20_FANCLUB = 'JOIN_20_FANCLUB',
}

export enum PeriodType {
  DAY = 'DAILY',
  WEEK = 'WEEKLY',
  MONTH = 'MONTHLY',
}
export type DashboardParamsType = {
  syntheticType: SyntheticType;
  periodType: PeriodType;
};

export type DashBoardExportStatisticParams = {
  fromDate: string;
  toDate: string;
}

export type DashBoardExportStatisticResponse = {
  blob: Blob;
  fileName: string;
  hasMore: boolean;
  totalFiles: number;
}

export type ChartDataType = {
  date: string;
  value?: number;
  blindBox?: number;
  quizGame?: number;
  predictionMatch?: number;
  fill?: string;
  logo?: string;
  name?: string;
};

export type DashboardRespItem = {
  period: string;
  total?: number;
  miniGame?: 'BLIND_BOX' | 'QUIZ_GAME' | 'PREDICTION_MATCH';
};

export enum MiniGameType {
  BLIND_BOX = 'blindBox',
  QUIZ_GAME = 'quizGame',
  PREDICTION_MATCH = 'predictionMatch',
}
class DashboardService {
  async getData(params?: PaginationRequest & DashboardParamsType): Promise<ChartDataType[]> {
    const res = await apiService.get('/b/dashboard', { params });
    const data = res?.data?.data || ([] as DashboardRespItem[]);
    const dataMapping = data.reduce((acc: Record<string, ChartDataType>, item: DashboardRespItem) => {
      const date = item?.period ?? '';

      if (!acc[date]) {
        acc[date] = { date, blindBox: 0, quizGame: 0, predictionMatch: 0, value: 0 };
      }

      if (item.total !== undefined) {
        if (!item.miniGame) {
          acc[date].value = (acc[date].value || 0) + item.total;
        } else {
          switch (item.miniGame) {
            case 'BLIND_BOX':
              acc[date].blindBox! += item.total;
              break;
            case 'QUIZ_GAME':
              acc[date].quizGame! += item.total;
              break;
            case 'PREDICTION_MATCH':
              acc[date].predictionMatch! += item.total;
              break;
          }
        }
      }
      return acc;
    }, {});

    const formattedData = Object.keys(dataMapping).map((date) => dataMapping[date]);
    if (formattedData.length > 0) {
      formattedData.unshift({ date: '', blindBox: 0, quizGame: 0, predictionMatch: 0, value: 0 });
    }
    return formattedData || [];
  }

  async exportStatistics(params: DashBoardExportStatisticParams & PaginationRequest): Promise<DashBoardExportStatisticResponse> {
    const res = await apiService.get('/b/dashboard/export-statistic', { params, responseType: 'blob' });

    const total = res.headers['x-total-count']

    const fileName = `${params.fromDate}_${params.toDate}_DanhSachLuotChoi${params.pageNo}.xlsx`;
    const hasMore = params.pageNo && params.pageSize ? (params.pageNo * params.pageSize) < total : false;
    const totalFiles = +(total / params.pageSize!).toFixed();

    return {
      blob: res.data,
      fileName,
      hasMore,
      totalFiles
    }
  }
}

const dashboardService = new DashboardService();
export default dashboardService;
